// import Swiper core and required modules
import { Navigation, Pagination, Lazy, A11y } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
  name: 'homeTestimonials',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ['sectionBlocks'],
  setup() {
    const onSwiper = (swiper) => {
      //console.log(swiper);
    };
    const onSlideChange = () => {
      //console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y],
    };
  },
  data() {
    return {
      product: null,
    };
  },
  methods: {},
};
